import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';
import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

export const useCreateProviderPin = () => {
  const { primaryOrganizationId: organizationId } = useSelector(
    (state: any) => state.login.user,
  );
  const { trackEvent } = useTrackEvent();

  return useMutation({
    mutationFn: async (data: {
      pmsProviderId: string;
      pmsPatientId: string;
      apptDate: string;
      featureName: string;
      tooth: string;
      notes?: string;
    }) => {
      const response = await makeAPIRequestReactQuery(
        `/${endpoints.videaInsights}/${organizationId}/recommendation-pins`,
        {},
        'post',
        {
          headers: {
            Org: organizationId,
          },
          data,
        },
      );
      trackEvent(mixpanelEvents.insightsPinCreate, {
        pmsProviderId: data.pmsProviderId,
        suggestionType: data.featureName,
        tooth: data.tooth,
      });
      return response;
    },
  });
};

export const useDeleteProviderPin = () => {
  const { primaryOrganizationId: organizationId } = useSelector(
    (state: any) => state.login.user,
  );
  const { trackEvent } = useTrackEvent();

  return useMutation({
    mutationFn: async (data: {
      pmsProviderId: string;
      pmsPatientId: string;
      apptDate: string;
      featureName: string;
      tooth: string;
    }) => {
      const response = await makeAPIRequestReactQuery(
        `/${endpoints.videaInsights}/${organizationId}/recommendation-pins`,
        {},
        'delete',
        {
          headers: {
            Org: organizationId,
          },
          data,
        },
      );
      trackEvent(mixpanelEvents.insightsPinDelete, {
        pmsProviderId: data.pmsProviderId,
        suggestionType: data.featureName,
        tooth: data.tooth,
      });
      return response;
    },
  });
};
